/**
 * Flow Visualization Utilities
 * WP-FLOW-7: Text truncation and formatting helpers
 */

/**
 * Truncate a string to a maximum length with ellipsis
 * @param str - String to truncate
 * @param maxLength - Maximum length including ellipsis
 * @returns Truncated string
 */
export function truncate(str: string, maxLength: number): string {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength - 1) + '\u2026'; // Unicode ellipsis
}

/**
 * Maximum characters that fit in account node at 12px font
 * Account nodes are 160px wide with 10px horizontal padding on each side
 * Usable width: 140px, at ~7px per char = 20 chars
 */
export const ACCOUNT_NAME_MAX_CHARS = 20;

/**
 * Maximum characters for income/expense labels (displayed outside node)
 * These have more space available but should still be reasonable
 */
export const FLOW_LABEL_MAX_CHARS = 16;
